export const getQueryParamValue = (queryParamValue: string | string[]): string =>
  Array.isArray(queryParamValue) ? queryParamValue[0] : queryParamValue;

export const isQueryParamValueTrue = (queryParamValue: string | string[]): boolean =>
  getQueryParamValue(queryParamValue) === 'true';
